// Services/signupService.js
import { supabase } from '../lib/supabaseClient';

const normalizeText = (value) => value?.trim?.() || value || null;

export async function saveSignup({ email, firstName, lastName, city, state, country }) {
  const {
    data: { user },
    error: userError,
  } = await supabase.auth.getUser();

  if (userError) {
    console.error('[signupService] getUser error ->', userError);
    throw userError;
  }

  if (!user?.id) {
    throw new Error('No authenticated user found for profile creation.');
  }

  const metadata = user.user_metadata || {};

  const payload = {
    id: user.id,
    email: (email || '').trim().toLowerCase(),
    first_name: normalizeText(firstName) || normalizeText(metadata.first_name),
    last_name: normalizeText(lastName) || normalizeText(metadata.last_name),
    city: normalizeText(city) || normalizeText(metadata.city),
    state: normalizeText(state) || normalizeText(metadata.state),
    country: normalizeText(country) || normalizeText(metadata.country),
    created_at: new Date().toISOString(),
  };

  const { error } = await supabase
    .from('profiles')
    .insert([payload]);

  if (error) {
    console.error('[signupService] insert error ->', error);
    throw error;
  }
}
